<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card v-if="thai_student==1 && sex=='M'" header-class="redmfu">
            <div slot="header" header-class="redmfu">
              <strong v-if="thai_student==1">ตอนที่ 1 ข้อมูลทั่วไป </strong>
              <strong v-else>Part 1 General Data </strong>
              <div style="float:right;">
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                  {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <div v-for="item in items" v-bind:key="item.QUESTION_PK" v-if="(thai_student==1 && sex=='M')">
              <div v-if="item.QUESTION_PK ==1">
                <b-form-group
                  class="text-danger"
                  v-if="items2[1].VALUES ==2"
                  :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  v-else
                  :label="item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
              </div>
              <div v-if="item.QUESTION_PK ==2">
                <b-form-group
                  class="text-danger"
                  v-if="items2[2].VALUES ==2"
                  :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  v-else
                  :label="item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
              </div>
              <div v-if="item.QUESTION_PK ==3">
                <b-form-group
                  class="text-danger"
                  v-if="items2[3].VALUES ==2"
                  :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  v-else
                  :label="item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
              </div>
              <div v-if="item.QUESTION_PK ==100">
                <b-form-group
                  class="text-danger"
                  v-if="items2[0].VALUES ==2"
                  :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  v-else
                  :label="item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
              </div>
              <b-form-group
                label-cols-sm="1"
                label
                label-align-sm="right"
                label-for="nested-street"
              >
                <b-form-checkbox-group
                  v-if="item.QUESTION_PK==100 "
                  v-model="selected_pr"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[0].ANS"
                  stacked
                  name="selected_pr"
                  @change="changePr"
                >
                  <b-form-input
                    v-if="selected_pr15==1"
                    id="selected_pr_txt"
                    type="text"
                    autocomplete="selected_pr_txt"
                    v-model="selected_pr_txt"
                    placeholder="Other..."
                  ></b-form-input>
                </b-form-checkbox-group>
                <b-form-radio-group
                  v-if="item.QUESTION_PK==3"
                  v-model="selected_work_status"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[3].ANS"
                  stacked
                  name="selected_work_status"
                >
<!--                  FULL_NAME == เอาข้อขึ้นด้วย-->

                </b-form-radio-group>
                <b-form-radio-group
                  v-if="item.QUESTION_PK==2 &&  sex=='M'"
                  v-model="selected_ordinate"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[2].ANS"
                  stacked
                  name="selected_ordinate"
                >
                </b-form-radio-group>
                <b-form-radio-group
                  v-if="item.QUESTION_PK==1 &&  sex=='M'"
                  v-model="selected_military"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[1].ANS"
                  stacked
                  name="selected_military"
                >
                  <!-- select:{{ selected_military }} -->
                </b-form-radio-group>
              </b-form-group>
            </div>
            <div>
            </div>
            <div
              v-if=" selected_work_status ==1 || selected_work_status ==2 ||selected_work_status ==3 || selected_work_status ==4  ||selected_work_status ==5 || selected_work_status ==6  || selected_work_status ==7   ">
              <b-form-group
                class="text-danger"
                v-if="items2[4].VALUES ==2"
                :label="'*  ' + num  + ') '+question_4"
                label-for="basicInlineRadios"
                :label-cols="12"
              ></b-form-group>
              <b-form-group
                v-else
                :label="num  + ') '+question_4"
                label-for="basicInlineRadios"
                :label-cols="12"
              ></b-form-group>
              <b-form-group
                label-cols-sm="1"
                label
                label-align-sm="right"
                label-for="nested-street"
              >
                <b-form-radio-group
                  v-if=" thai_student==1 && (selected_work_status==1 || selected_work_status==2 || selected_work_status==5 || selected_work_status==6 || selected_work_status==7)"
                  v-model="selected_income"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="option_thai_12"
                  stacked
                  name="selected_income"
                >
                </b-form-radio-group>
                <b-form-radio-group
                  v-if=" thai_student==0 && (selected_work_status==1 || selected_work_status==2 || selected_work_status==5 || selected_work_status==6 || selected_work_status==7)"
                  v-model="selected_income"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="option_eng_12"
                  stacked
                  name="selected_income"
                >
                </b-form-radio-group>
                <b-form-radio-group
                  v-if=" thai_student==1 && (selected_work_status==3 || selected_work_status==4 )"
                  v-model="selected_income"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="option_thai_34"
                  stacked
                  name="selected_income"
                >
                </b-form-radio-group>
                <b-form-radio-group
                  v-if=" thai_student==0 && (selected_work_status==3 || selected_work_status==4 )"
                  v-model="selected_income"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="option_eng_34"
                  stacked
                  name="selected_income"
                >
                </b-form-radio-group>
              </b-form-group>

            </div>
            <div slot="footer" class="text-center">
              <b-button type="submit" size="md" class="mr-2" variant="success " @click="onBack">
                <i class="fa fa-arrow-circle-o-left"></i> Back
              </b-button>

              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>

              <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                <i class="fa fa-ban"></i> Reset
              </b-button>
            </div>
          </b-card>
          <b-card v-else header-class="redmfu"><!--หญิง-->
            <div slot="header">
              <strong v-if="thai_student==1">ตอนที่ 1 ข้อมูลทั่วไป </strong>
              <strong v-else>Part 1 General Information </strong>
              <div style="float:right;">
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                  {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <div v-for="item in items" v-bind:key="item.QUESTION_PK">
              <div v-if="item.QUESTION_PK ==3">
                <b-form-group
                  class="text-danger"
                  v-if="items2[1].VALUES ==2"
                  :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  v-else
                  :label="item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
              </div>
              <div v-if="item.QUESTION_PK ==100">
                <b-form-group
                  class="text-danger"
                  v-if="items2[0].VALUES ==2"
                  :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  v-else
                  :label="item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
              </div>
              <b-form-group
                label-cols-sm="1"
                label
                label-align-sm="right"
                label-for="nested-street"
              >
                <b-form-checkbox-group
                  v-if="item.QUESTION_PK==100 "
                  v-model="selected_pr"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[0].ANS"
                  stacked
                  name="selected_pr"
                  @change="changePr"
                >
                  <b-form-input
                    v-if="selected_pr15==1"
                    id="selected_pr_txt"
                    type="text"
                    autocomplete="selected_pr_txt"
                    v-model="selected_pr_txt"
                    placeholder="Other..."
                  ></b-form-input>
<!--                                        {{ selected_pr }}-->
                </b-form-checkbox-group>

                <b-form-radio-group
                  v-if="item.QUESTION_PK==3"
                  v-model="selected_work_status"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[1].ANS"
                  stacked
                  name="selected_work_status"
                >
                  <!--    FULL_NAME      BYTEDES         &lt;!&ndash; select:{{ selected_work_status }} &ndash;&gt;-->
                </b-form-radio-group>
              </b-form-group>
            </div>
<!--            {{ num }}{{ question_4 }}-->
<!--            ==={{ selected_work_status }}===-->
            <div
              v-if=" selected_work_status ==1 || selected_work_status ==2 ||selected_work_status ==3 || selected_work_status ==4  ||selected_work_status ==5 || selected_work_status ==6  || selected_work_status ==7   ">
              <b-form-group
                class="text-danger"
                v-if="items2[2].VALUES ==2"
                :label="'*  ' + num  + ') '+question_4"
                label-for="basicInlineRadios"
                :label-cols="12"
              ></b-form-group>
              <b-form-group
                v-else
                :label="num  + ') '+question_4"
                label-for="basicInlineRadios"
                :label-cols="12"
              ></b-form-group>
              <b-form-group
                label-cols-sm="1"
                label
                label-align-sm="right"
                label-for="nested-street"
              >
                <b-form-radio-group
                  v-if=" thai_student==1 && (selected_work_status==1 || selected_work_status==2 || selected_work_status==5 || selected_work_status==6 || selected_work_status==7)"
                  v-model="selected_income"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="option_thai_12"
                  stacked
                  name="selected_income"
                >
                </b-form-radio-group>
                <b-form-radio-group
                  v-if=" thai_student==0 && (selected_work_status==1 || selected_work_status==2 || selected_work_status==5 || selected_work_status==6 || selected_work_status==7)"
                  v-model="selected_income"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="option_eng_12"
                  stacked
                  name="selected_income"
                >
                </b-form-radio-group>
<!--                {{option_thai_12}}-->
<!--                {{option_thai_34}}-->
<!--                <br>{{selected_work_status}}-->
                <b-form-radio-group
                  v-if=" thai_student==1 && (selected_work_status==3 || selected_work_status==4 )"
                  v-model="selected_income"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="option_thai_34"
                  stacked
                  name="selected_income"
                >
                </b-form-radio-group>
                <b-form-radio-group
                  v-if=" thai_student==0 && (selected_work_status==3 || selected_work_status==4 )"
                  v-model="selected_income"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="option_eng_34"
                  stacked
                  name="selected_income"
                >
                </b-form-radio-group>
              </b-form-group>
            </div>


            <div slot="footer" class="text-center">
              <b-button type="submit" size="md" class="mr-2" variant="success " @click="onBack">
                <i class="fa fa-arrow-circle-o-left"></i> Back
              </b-button>

              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>

              <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                <i class="fa fa-ban"></i> Reset
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- <div slot="footer" class="text-center">
        <b-button type="submit" size="sm" variant="primary" @click="onSubmit">
          <i class="fa fa-dot-circle-o"></i> Submit
        </b-button>

        <b-button type="reset" size="sm" variant="danger" @click="onReset">
          <i class="fa fa-ban"></i> Reset
        </b-button>
      </div> -->

      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>

    <b-modal v-if="thai_student==1"
             title="คุณกรอกข้อมูลไม่ครบถ้วน"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal v-if="thai_student==0"
             title="You didn’t fill your information completely"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreatePart1",
  data() {
    return {
      number: 0,
      student: {},
      student2: {},
      std_id: "",
      selected_pr: "",
      selected_pr15: "",
      selected_pr_txt: "",
      selected_military: "",
      selected_ordinate: "",
      selected_income: "",
      selected_work_status: "",
      question_4: "",
      sex: "",
      num: 0,
      numEror: 0,
      current_erorrtxt: "",
      dangerModal: false,
      items: [],
      items2: [],
      actionUpdate: 10,
      option_thai_12: [
        {BYTECODE: "1", BYTEDES: "มีรายได้ จากงานประจำ   ", CONTROL_ANS: 0, QUESTION_PK: 4}
        , {BYTECODE: "2", BYTEDES: "มีรายได้ จากงานที่ไม่ใช่งานประจำ หรือรายได้จากแหล่งอื่น  ", CONTROL_ANS: 0, QUESTION_PK: 4}
      ],
      option_eng_12: [
         {BYTECODE: "1", BYTEDES: "Income from employment  ", CONTROL_ANS: 0, QUESTION_PK: 4}
        , {BYTECODE: "2", BYTEDES: "Income from other sources unrelated to employment ", CONTROL_ANS: 0, QUESTION_PK: 4}

      ],
      option_thai_34: [
        //{BYTECODE: "2", BYTEDES: "มีรายได้ จากงานที่ไม่ใช่งานประจำ หรือรายได้จากแหล่งอื่น  ", CONTROL_ANS: 0, QUESTION_PK: 4}
        {BYTECODE: "3", BYTEDES: "ไม่มีงานทำ แต่มีรายได้ จากแหล่งอื่น", CONTROL_ANS: 0, QUESTION_PK: 4}
        , {BYTECODE: "4", BYTEDES: "ไม่มีงานทำ และไม่มีรายได้ ", CONTROL_ANS: 0, QUESTION_PK: 4}
      ],
      option_eng_34: [
         {BYTECODE: "3", BYTEDES: "No job, but receives income from other sources.", CONTROL_ANS: 0, QUESTION_PK: 4}
        , {BYTECODE: "4", BYTEDES: "No job, no income", CONTROL_ANS: 0, QUESTION_PK: 4}
      ],
      part2: "",
      part3: "",
      part4: ""
    };
  },

  methods: {
    onBack() {
      this.$router.push("/General");
    },
    changePr(checked) {
      // console.log("checked==", checked);
      var checked15 = 0
      for (var i = 0; i < checked.length; i++) {
        if (checked[i] == 15) {
          checked15 = 1;
        }
      }
      if (checked15 == 1) {
        this.selected_pr15 = 1;
      } else {
        this.selected_pr15 = 0;
      }
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          var currentSt = res.data.data[0];
          if (res.data.data.length == 1) {
            this.actionUpdate = 1;
            // console.log(" actionUpdate==",this.actionUpdate);
            // console.log(" currentSt",currentSt);
            // console.log(" getCurrentStudent มีข้อมูล",this.actionUpdate);
            this.part2 = currentSt.QN_OCCUP_TYPE;
            this.part3 = currentSt.QN_CAUSE_NOWORK;
            this.part4 = currentSt.QN_LEVEL_EDU;

            this.std_id = this.student.STUDENTID;
            var selectedData = [];
            var j = -1;
            if (currentSt.QN_PR1 != null) {
              j = j + 1;
              selectedData[j] = 1;
            }
            if (currentSt.QN_PR2 != null) {
              j = j + 1;
              selectedData[j] = 2;
            }
            if (currentSt.QN_PR3 != null) {
              j = j + 1;
              selectedData[j] = 3;
            }
            if (currentSt.QN_PR4 != null) {
              j = j + 1;
              selectedData[j] = 4;
            }
            if (currentSt.QN_PR5 != null) {
              j = j + 1;
              selectedData[j] = 5;
            }
            if (currentSt.QN_PR6 != null) {
              j = j + 1;
              selectedData[j] = 6;
            }
            if (currentSt.QN_PR7 != null) {
              j = j + 1;
              selectedData[j] = 7;
            }
            if (currentSt.QN_PR8 != null) {
              j = j + 1;
              selectedData[j] = 8;
            }
            if (currentSt.QN_PR9 != null) {
              j = j + 1;
              selectedData[j] = 9;
            }
            if (currentSt.QN_PR10 != null) {
              j = j + 1;
              selectedData[j] = 10;
            }
            if (currentSt.QN_PR11 != null) {
              j = j + 1;
              selectedData[j] = 11;
            }
            if (currentSt.QN_PR12 != null) {
              j = j + 1;
              selectedData[j] = 12;
            }
            if (currentSt.QN_PR13 != null) {
              j = j + 1;
              selectedData[j] = 13;
            }
            if (currentSt.QN_PR14 != null) {
              j = j + 1;
              selectedData[j] = 14;
            }
            if (currentSt.QN_PR15 != null) {
              j = j + 1;
              selectedData[j] = 15;
              this.selected_pr15 = 1;
              this.selected_pr_txt = currentSt.QN_PR15_TXT;
            }
            // console.log(" selectedData",selectedData);
            this.selected_pr = selectedData;

            if (this.thai_student == 1 && this.sex == "M") {
              this.selected_military = currentSt.QN_MILITARY_STATUS;
              this.selected_ordinate = currentSt.QN_ORDINATE_STATUS;
            } else {
              this.selected_military = "";
              this.selected_ordinate = "";
            }
            this.selected_work_status = currentSt.QN_WORK_STATUS;
            this.selected_income = currentSt.QN_INCOME;
          } else {
            this.actionUpdate = 0;
            console.log(" getCurrentStudent ไม่มีข้อมูล", this.actionUpdate);
            this.$router.push("Logout");
          }
          return this.actionUpdate;
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          this.actionUpdate = 10;
          console.log(" actionUpdate==", this.actionUpdate);
          this.$router.push("Logout");
        });
    },
    setStudent: function () {
      var student = {};
      // console.log("user==", this.$store.state.user)
      student.std_id = this.$store.state.user.studentid;
      student.qn_year = this.$store.state.user.year;
      student.selected_pr1 = "";
      student.selected_pr2 = "";
      student.selected_pr3 = "";
      student.selected_pr4 = "";
      student.selected_pr5 = "";
      student.selected_pr6 = "";
      student.selected_pr7 = "";
      student.selected_pr8 = "";
      student.selected_pr9 = "";
      student.selected_pr10 = "";
      student.selected_pr11 = "";
      student.selected_pr12 = "";
      student.selected_pr13 = "";
      student.selected_pr14 = "";
      student.selected_pr15 = "";
      student.selected_pr_txt = "";
      student.selected_military = this.selected_military;
      if ((this.selected_military == null) || (this.selected_military == '')) {
        this.items2[1].VALUES = 2;
      } else {
        this.items2[1].VALUES = 1;
      }
      student.selected_ordinate = this.selected_ordinate;
      if ((this.selected_ordinate == null) || (this.selected_ordinate == '')) {
        this.items2[2].VALUES = 2;
      } else {
        this.items2[2].VALUES = 1;
      }
      student.selected_work_status = this.selected_work_status;
      student.selected_income = this.selected_income;
      // console.log("sex==",this.sex)
      if (this.sex == "M") {
        if ((this.selected_work_status == null) || (this.selected_work_status == '')) {
          this.items2[3].VALUES = 2;
        } else {
          this.items2[3].VALUES = 1;
        }
        if ((this.selected_income == null) || (this.selected_income == '')) {
          this.items2[4].VALUES = 2;
        } else {
          this.items2[4].VALUES = 1;
        }
      } else {

        if ((this.selected_work_status == null) || (this.selected_work_status == '')) {
          this.items2[1].VALUES = 2;
        } else {
          this.items2[1].VALUES = 1;
        }
        if ((this.selected_income == null) || (this.selected_income == '')) {
          this.items2[2].VALUES = 2;
        } else {
          this.items2[2].VALUES = 1;
        }
      }
      for (var i = 0; i < this.selected_pr.length; i++) {
        if (this.selected_pr[i] == 1) {
          student.selected_pr1 = 1;
        }
        if (this.selected_pr[i] == 2) {
          student.selected_pr2 = 1;
        }
        if (this.selected_pr[i] == 3) {
          student.selected_pr3 = 1;
        }
        if (this.selected_pr[i] == 4) {
          student.selected_pr4 = 1;
        }
        if (this.selected_pr[i] == 5) {
          student.selected_pr5 = 1;
        }
        if (this.selected_pr[i] == 6) {
          student.selected_pr6 = 1;
        }
        if (this.selected_pr[i] == 7) {
          student.selected_pr7 = 1;
        }
        if (this.selected_pr[i] == 8) {
          student.selected_pr8 = 1;
        }
        if (this.selected_pr[i] == 9) {
          student.selected_pr9 = 1;
        }
        if (this.selected_pr[i] == 10) {
          student.selected_pr10 = 1;
        }
        if (this.selected_pr[i] == 11) {
          student.selected_pr11 = 1;
        }
        if (this.selected_pr[i] == 12) {
          student.selected_pr12 = 1;
        }
        if (this.selected_pr[i] == 13) {
          student.selected_pr13 = 1;
        }
        if (this.selected_pr[i] == 14) {
          student.selected_pr14 = 1;
        }
        if (this.selected_pr[i] == 15) {
          student.selected_pr15 = 1;
          student.selected_pr_txt = this.selected_pr_txt
          //.replaceAll( "'", "`");
        }
      }
      if (this.selected_pr.length == 0) {
        this.items2[0].VALUES = 2;
      } else {
        this.items2[0].VALUES = 1;
      }

      // student.selected_pr1
      // console.log("setStudent==", this.items2);
      // console.log("setStudent==", student);
      return student;
    },
    getErrorTxt: function (student) {
      this.current_erorrtxt = "";
      this.numEror = 0;
      var substring = "--";
      var substring1 = "..";
      var substring2 = "55";
      var quotation1 = "'";
      var quotation2 = "`";
      // console.log("xxx=", this.selected_pr_txt)
      // console.log("student.selected_pr15==",student.selected_pr15)
      if ((student.selected_pr15 == 1)) {
        if ((this.selected_pr_txt == "") || (this.selected_pr_txt == null) || (this.selected_pr_txt == undefined) || (this.selected_pr_txt == 'None')) {
          this.numEror = this.numEror + 1;
          this.items2[0].VALUES = 2;
          this.current_erorrtxt =
            this.thai_student == "1"
              ? this.current_erorrtxt + "/อื่นๆ.. "
              : this.current_erorrtxt + "/Other ";
        }else{
          if (student.selected_pr_txt.toString().length > 0){
            if (student.selected_pr_txt.toString().includes(quotation1)) {
              student.selected_pr_txt = student.selected_pr_txt.replaceAll(quotation1, "''");
            }
            if (student.selected_pr_txt.toString().includes(quotation2)) {
              student.selected_pr_txt = student.selected_pr_txt.replaceAll(quotation2, "''");
            }
          if ((this.selected_pr_txt != "") && ((this.selected_pr_txt.includes(substring)) || (this.selected_pr_txt.includes(substring1) || (this.selected_pr_txt.includes(substring2))))) {
            this.numEror = this.numEror + 1;
            this.items2[0].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ --" : this.current_erorrtxt + "/Other --";
          }
          if ((this.selected_pr_txt == "-") || (this.selected_pr_txt == ".") || (this.selected_pr_txt == "None") || (this.selected_pr_txt == "--") || (this.selected_pr_txt == "55")) {
            this.numEror = this.numEror + 1;
            this.items2[0].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ -" : this.current_erorrtxt + "/Other -";
          }
          }
        }


      }
      if (this.selected_pr.length == 0) {
        this.numEror = this.numEror + 1;
        this.items2[0].VALUES = 2;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/รับทราบข้อมูลข่าวสารของมฟล. "
            : this.current_erorrtxt + "/ xxxxx";
      }
      if (this.thai_student == 1 && this.sex == "M") {
        if ((this.selected_military == "") || (this.selected_military == null) || (this.selected_military == undefined)) {
          this.numEror = this.numEror + 1;
          this.items2[1].VALUES = 2;
          this.current_erorrtxt =
            this.thai_student == "1"
              ? this.current_erorrtxt + "/สถานะเกณฑ์ทหาร"
              : this.current_erorrtxt + "/";
        }
        if ((this.selected_ordinate == "") || (this.selected_ordinate == null) || (this.selected_ordinate == undefined)) {
          this.numEror = this.numEror + 1;
          this.items2[2].VALUES = 2;
          this.current_erorrtxt =
            this.thai_student == "1"
              ? this.current_erorrtxt + "/สถานะการเป็นนักบวช"
              : this.current_erorrtxt + "/";
        }
      }
      if ((this.sex == 'M')&&(this.thai_student==1)) {
        if ((this.selected_work_status == "") || (this.selected_work_status == null) || (this.selected_work_status == undefined)) {
          this.numEror = this.numEror + 1;
          this.items2[3].VALUES = 2;
          this.current_erorrtxt =
            this.thai_student == "1"
              ? this.current_erorrtxt + "/สถานภาพการทำงาน"
              : this.current_erorrtxt + "/Work status";
        }
        var check_income=0
        // console.log("selected_income==",this.selected_income)
        if ((this.selected_income == "") || (this.selected_income == null) || (this.selected_income == undefined)) {
          this.numEror = this.numEror + 1;
          this.items2[4].VALUES = 2;
          this.current_erorrtxt =
            this.thai_student == "1"
              ? this.current_erorrtxt + "/รายได้หลังสำเร็จการศึกษา"
              : this.current_erorrtxt + "/Income";
        }else{
          check_income= this.checkIncome(this.selected_work_status);
          if (check_income==0){
            this.numEror = this.numEror + 1;
            this.items2[4].VALUES = 2;
            this.current_erorrtxt =
              this.thai_student == "1"
                ? this.current_erorrtxt + "/รายได้หลังสำเร็จการศึกษา *"
                : this.current_erorrtxt + "/Income *";
          }
        }
      } else {
        if ((this.selected_work_status == "") || (this.selected_work_status == null) || (this.selected_work_status == undefined)) {
          this.numEror = this.numEror + 1;
          this.items2[1].VALUES = 2;
          this.current_erorrtxt =
            this.thai_student == "1"
              ? this.current_erorrtxt + "/สถานภาพการทำงาน"
              : this.current_erorrtxt + "/Work status";
        }

        if ((this.selected_income == "") || (this.selected_income == null) || (this.selected_income == undefined)) {
          this.numEror = this.numEror + 1;
          this.items2[2].VALUES = 2;
          this.current_erorrtxt =
            this.thai_student == "1"
              ? this.current_erorrtxt + "/รายได้หลังสำเร็จการศึกษา"
              : this.current_erorrtxt + "/Income";
        }else{
          check_income= this.checkIncome(this.selected_work_status);
          if (check_income==0){
            this.numEror = this.numEror + 1;
            this.items2[2].VALUES = 2;
            this.current_erorrtxt =
              this.thai_student == "1"
                ? this.current_erorrtxt + "/รายได้หลังสำเร็จการศึกษา *"
                : this.current_erorrtxt + "/Income *";
          }
        }
      }
      // console.log("items2==", this.items2)
      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      student.num_error=this.numEror;
      return student;
    },
    checkIncome(work_status){
      var check=10;
      // console.log("w=",work_status);
      // console.log("selected_income=",this.selected_income);
      if((work_status==1)||(work_status==2)||(work_status==5)||(work_status==6)||(work_status==7)){
        if ((this.selected_income==1) || (this.selected_income==2)){
          check=1
        }else{
          check=0;
        }
      }
      if((work_status==3)||(work_status==4)){
        if ((this.selected_income==4) || (this.selected_income==3)) {
          check=1
        }else{
          check=0;
        }
      }
      // console.log("check==",check)
      return check;
    },
    onReset() {
      this.selected_work_status = "";
      this.selected_military = "";
      this.selected_ordinate = "";
      this.selected_pr = "";
    },
    onSubmit() {
      var student = {};
      student = this.setStudent();
      var s = this.getErrorTxt(student);
      // console.log("ss=",this.actionUpdate)
      if (s.num_error == 0) {
        if (this.actionUpdate == 0) {
          // ยังไม่ได้ทำ general เลย
          this.$router.push("/general");
        } else if (this.actionUpdate == 1) {
          // console.log("===UPDATE===");
          this.onUpdateData(s);
        } else {
          // เข้ามาได้ไง
        }
      }
    },
    nextPart() {
      /* if (
         this.selected_work_status == 1 ||
         this.selected_work_status == 2 ||
         this.selected_work_status == 5 ||
         this.selected_work_status == 6 ||
         this.selected_work_status == 7
       ) {
         this.$router.push("/Part2?x=" + this.number);
       } else if (this.selected_work_status == 3) {
         this.$router.push("/Part3?x=" + this.number);
       } else if (this.selected_work_status == 4) {
         this.$router.push("/Part4?x=" + this.number);
       } else {
         this.$router.push("/Part1?x=" + this.number);
         console.log(" error", this.selected_work_status);
       } */
    },
    /*  setStudentUserQ1(student) {
        student.std_id = this.$store.state.user.studentid;
        student.qn_year = this.$store.state.user.year;
        student.questionnaire_1 = 0;
      },*/
    /* onUpdateUserQ1(student) {

       api
         .updateStudentUserQuestion(student)
         .then(res => {
           // console.log(res);
           this.message = res.message;
           // console.log("update ผ่าน", student);
           this.nextPart();
         })
         .catch(err => {

           console.log("onUpdateUserQ1 error", err.toString());
         })

     }, */
    setStudentClear2(student) {
      student.std_id = this.$store.state.user.studentid;
      student.qn_year = this.$store.state.user.year;
      student.selected_occup_type = "";
      student.qn_occup_type_txt = "";
      student.qn_occup_type_txt4 = "";
      student.selected_mfii = "";
      student.qn_mfii_txt = "";
      student.selected_talent = "";
      student.qn_talent_txt = "";
      student.select_position = "";
      student.current_position = "";
      student.current_department_name = "";
      student.current_office = "";
      student.selected_work_type = "";
      student.select_country = "";
      student.current_address = "";
      student.current_no = "";
      student.current_moo = "";
      student.current_building = "";
      student.current_lane = "";
      student.current_road = "";
      student.select_province = "";
      student.select_district = "";
      student.select_subdistrict = "";
      student.select_subdistrict_name = "";
      student.current_zipcode = "";
      student.current_tel = "";
      student.current_fax = "";
      student.current_email = "";
      student.current_salary = "";
      student.selected_work_satisfy = "";
      student.qn_work_satisfy_txt = "";
      student.select_country_name = "";
      student.selected_time_findwork = "";
      student.selected_match_edu = "";
      student.selected_apply_edu = "";
      student.selected_work_success1 = "";
      student.selected_work_success2 = "";
      student.selected_work_success3 = "";
      student.qn_work_success1_txt = "";
      student.qn_work_success2_txt = "";
      student.qn_work_success3_txt = "";
      student.selected_require_edu = "";

      console.log("student2 ", student);
    },
    setStudentClear3(student) {
      student.std_id = this.$store.state.user.studentid;
      student.selected_cause_nowork = "";
      student.qn_cause_nowork_txt = "";
      student.selected_prob_findwork_0 = "";
      student.qn_prob_findwork_txt = "";
      student.selected_prob_findwork_1 = "";
      student.selected_prob_findwork_2 = "";
      student.selected_prob_findwork_3 = "";
      student.selected_prob_findwork_4 = "";
      student.selected_prob_findwork_5 = "";
      student.selected_prob_findwork_6 = "";
      student.selected_prob_findwork_7 = "";
      student.selected_prob_findwork_8 = "";
      student.selected_prob_findwork_9 = "";
      student.selected_prob_findwork_10 = "";
      student.selected_prob_findwork_11 = "";
      student.selected_prob_findwork_12 = "";
      student.selected_prob_findwork_13 = "";
      student.selected_prob_findwork_14 = "";
      student.selected_workneed_id = "";
      student.select_country = "";
      student.select_position = "";
      student.current_position = "";
      student.current_skill = "";
      student.selected_disclosure = "";
      student.selected_require_edu = "";
      // console.log("setStudentClear3==", student);
      return student;
    },
    setStudentClear4(student) {
      student.std_id = this.$store.state.user.studentid;
      student.selected_level_edu = "";
      student.selected_program_edu = "";
      student.selected_program_id = "";
      student.selected_program_name = "";
      student.selected_type_univ = "";
      student.selected_cause_edu = "";
      student.qn_cause_edu_txt = "";
      student.selected_prob_edu = "";
      student.selected_prob_edu_0 = "";
      student.selected_prob_edu_1 = "";
      student.selected_prob_edu_2 = "";
      student.selected_prob_edu_3 = "";
      student.selected_prob_edu_4 = "";
      student.selected_prob_edu_5 = "";
      student.selected_prob_edu_6 = "";
      student.qn_prob_edu_txt = "";
      student.qn_prob_edu_txt = "";
      console.log("setStudentClear4==", student);
      return student;
    },
    /*onUpdateClearPart2(student) {
      api
        .updateStudentPart2(student)
        .then(res => {
          // console.log(res);
          this.message = res.message;
          console.log("onUpdateClearPart2 ผ่าน", this.studentId);
        })
        .catch(err => {
          console.log("onUpdateClearPart2 error", err.toString());
        });
    },*/
    /* onUpdateClearPart3(student) {
       api
         .updateStudentPart3(student)
         .then(res => {
           // console.log(res);
           this.message = res.message;
           // console.log("updateStudentPart3 ผ่าน", this.studentId);
         })
         .catch(err => {
           console.log("updateStudentPart3 error", err.toString());
         });
     },*/
    /* onUpdateClearPart4(student) {
       api
         .updateStudentPart4(student)
         .then(res => {
           // console.log(res);
           this.message = res.message;
           // console.log("updateStudentPart4 ผ่าน", this.studentId);
         })
         .catch(err => {
           console.log("updateStudentPart4 error", err.toString());
         });
     },*/
    onUpdateData(student) {
      api
        .updateStudentPart1(student)
        .then(res => {
          // console.log("updateStudentPart1 ==",res);
          this.message = res.message;
          if (res.data.code == 200) {
            if (this.selected_income == 1 || this.selected_income == 2 ) {
              this.$router.push("part2?x=" + this.number);
            } else if ( this.selected_income == 3 || this.selected_income == 4) {
              this.$router.push("part3?x=" + this.number);
            } else {
              this.$router.push("part1");
            }
          } else {
            this.$router.push("part1");
          }
          // console.log("updatePart1 ผ่าน", this.student);
          /*  if (this.selected_work_status == 3) {
              var studentquestion = {};
              if ((this.part2 != "") && (this.part2 != null)) {
                this.setStudentClear2(studentquestion);
                this.onUpdateClearPart2(studentquestion);
              }
              if ((this.part4 != "") && (this.part4 != null)) {
                this.setStudentClear4(studentquestion);
                this.onUpdateClearPart4(studentquestion);
              }
            }*/
          /* if (this.selected_work_status == 4) {
             var studentquestion = {};
             if ((this.part2 != "") && (this.part2 != null)) {
               this.setStudentClear2(studentquestion);
               this.onUpdateClearPart2(studentquestion);
             }
             if ((this.part3 != "") && (this.part3 != null)) {
               this.setStudentClear3(studentquestion);
               this.onUpdateClearPart3(studentquestion);
             }
           }*/
          /* if ((this.selected_work_status == 1) || (this.selected_work_status == 2) || (this.selected_work_status == 5) || (this.selected_work_status == 6) || (this.selected_work_status == 7)) {
             var studentquestion = {};
             if ((this.part3 != "") && (this.part3 != null)) {
               // console.log("22222222222");
               this.setStudentClear3(studentquestion);
               this.onUpdateClearPart3(studentquestion);
             }
           }*/
          // this.setStudentUserQ1(studentquestion);
          // this.onUpdateUserQ1(studentquestion);
          this.nextPart();
        })
        .catch(err => {
          console.log("updatePart1 error", err.toString());
          this.$router.push("Logout");
        });
    },
    getQuestion: function (section, sex, thaistudent) {
      api
        .getQuestionBySection(section, sex, thaistudent)
        .then(res => {
          // console.log("คำถาม==",res.data.data,section, sex, thaistudent);
          var number = 0;
          for (var i = 0; i < res.data.data.length; i++) {
            number = number + 1;
            res.data.data[i].NUMBER = number;

          }
          this.items = res.data.data;
          this.num = number;
          // console.log("items==",this.items);
          if ((sex == 'M')&&(this.thai_student==1)) {
            this.question_4 = this.items[4].QUESTION_NAME;
          } else {
            this.question_4 = this.items[2].QUESTION_NAME;
          }
          // console.log("question_4==", this.question_4);
          this.number = number;
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    }
  },
  mounted() {
  },
  created() {
    for (var j = 0; j <= 4; j++) {
      var b;
      if (j == 0) {
        b = {ID: 100, UPDATEDATA: 0, VALUES: 0}
      } else {
        b = {ID: j, UPDATEDATA: 0, VALUES: 0}
      }
      this.items2.push(b);
    }
    // console.log("created=", this.items2)
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Logout");
    } else {
      // this.$router.push("/Dashboard");
    }

    this.std_id = this.$store.state.user.studentid;
    this.thai_student = this.$store.state.user.thaistudent;
    this.sex = this.$store.state.user.sex;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    // console.log("actionUpdate=", this.actionUpdate)
    this.getQuestion(1, this.sex, this.thai_student);

    // this.getStudentByID(id);


  }
};
</script>
<style>
</style>
